import { createRequestActionTypes } from '../../helpers'

export const FETCH_RELATED = createRequestActionTypes(
  'RELATED_SIDEBAR',
  'RELATED'
)
export const FETCH_INLINE_RELATED = createRequestActionTypes(
  'RELATED_SIDEBAR',
  'INLINE_RELATED'
)
export const FETCH_SWIMLANE = createRequestActionTypes(
  'RELATED_SIDEBAR',
  'SWIMLANE'
)



// WEBPACK FOOTER //
// ./src/containers/RelatedSidebar/constants.js